export default "__VITE_ASSET__D5hQrv3b__"